import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "../lib/api";
import { useAuth } from "../components/AuthProvider";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * Handles `#session_id=...` fragment after Google OAuth → exchanges for session_token,
 * stores cookie via backend, refreshes auth context, and routes the user.
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin/login");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const me = await exchangeSession(sessionId);
        await refresh();
        // Strip fragment, route to admin if allowed otherwise show "not authorized"
        window.history.replaceState({}, "", window.location.pathname);
        if (me.is_admin) navigate("/admin", { replace: true });
        else navigate("/admin/login?denied=1", { replace: true });
      } catch {
        navigate("/admin/login?error=1", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen bg-warm-ivory flex items-center justify-center">
      <p className="text-charcoal-ink">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
